import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormCommonModule } from '@x/common/form';
import { LoaderModule } from '@x/common/loader';
import { AddToCartButtonComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/add-to-cart-button/add-to-cart-button.component';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';

@NgModule({
  declarations: [AddToCartButtonComponent],
  imports: [
    CommonModule,
    MatTooltipModule,
    UtilsModule,
    MatButtonModule,
    MatInputModule,
    FormCommonModule,
    LoaderModule,
  ],
  exports: [AddToCartButtonComponent],
})
export class AddToCartButtonModule {}
